exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".list-group{margin:50px 0 20px 0}.ProgressBarOutline{padding:5px;margin:10px;border-top:1px solid grey;border-bottom:1px solid grey}.wishCount{padding-top:5px;padding-bottom:5px;vertical-align:middle}.ProgressBar{padding-top:15px;padding-bottom:15px}.pagination{display:inline-block}.pagination li{float:left;font-size:18px;font-weight:200;padding:1px 2px;text-decoration:none;border-radius:5px}.pagination li a:hover{background-color:#ddd !important;border-radius:5px}.pagination li a:active{background-color:none !important;border-radius:5px}.pagination li a:focus{background-color:#fff !important;color:#000 !important;border-radius:5px}.pagination li.active a{background-color:white;font-size:18px;font-weight:500;border:0px;color:#b60135 !important}.pagination li a{background-color:white;border:0px;color:black}.pagination li a:focus{font-size:18px;font-weight:500;background-color:#b60135;border:0px;color:black}.pagination li a:visited{border:0px;color:black}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/List.scss
// module id = 636
// module chunks = 0